var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.viewedText)),(_vm.text.length > _vm.textLength)?_c('v-btn',{staticClass:"ma-2",attrs:{"small":"","color":_vm.buttonColor},on:{"click":_vm.viewtext}},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }